<template>
  <div>
    <title-all-transaction title="Transações"></title-all-transaction>
    <history></history>
  </div>
</template>

<script>
import History from "./transactions/History";
import Title from "../geral/Title";
export default {
  name: "Transactions",
  components: { "title-all-transaction": Title, History }
};
</script>

<style scoped></style>
